import React from 'react';

import styles from './styles.module.scss';
import {Startup, StarDuotone, StartupSecondary, ArrowForward} from '../../../assets';
import {Button} from '../../Button';

export const BottomCard = ({secondary}) => {
  return (
    <div className={styles.bottomCard}>
      <div className={styles.left}>
        <h4 className={styles.title}>Supercharge your business with Themis</h4>
        <div className={styles.subscription}>
          Get in touch now and get free
          <span className={styles.textLabel}>{<StarDuotone />}Enterprise</span> package with
          exclusive features for your business.
        </div>

        <Button
          text="Contact Now"
          icon={
            <div className={styles.buttonArrow}>
              <ArrowForward />
            </div>
          }
        />
      </div>
      <div className={styles.right}>{secondary ? <StartupSecondary /> : <Startup />}</div>
    </div>
  );
};
